import { BaseNotificationItem } from 'nomst/Stores/Notification/baseNotificationItem';
import { NotificationName, NotificationCategory } from 'typings/enums';
import { INotificationItemView } from 'components/Notification/notificationItemView';
import NotificationItemWorkflowApprovedView from 'components/Notification/notificationItemWorkflowApprovedView';
import { navigateToNoMst } from 'utils/MobxDataManager/singletons';

export class NotificationItemWorkflowApproved extends BaseNotificationItem {

    declare data: INotificationDataWorkflowApproved;

    constructor(props: IBaseNotificationItem) {
        super(props);
        this.notificationName = NotificationName.NotificationDataWorkflowApproved;
        this.category = NotificationCategory.YourTeam;
    }

    get titleText(): string {
        return 'Your team decision has been approved!';
    }

    get renderedComponent(): INotificationItemView {
        return NotificationItemWorkflowApprovedView;
    }

    get iconCss(): string {
        return '';
    }

    get contentText(): string {
        return '';
    }

    get employeeName(): string {
        return '';
    }

    onClick(): void {
        navigateToNoMst.navigateToTeamsView(null,
            Array.isArray(this.data.managerSourceId) ? this.data.managerSourceId :
                [this.data.managerSourceId]
        );
        this.afterClick();
    }
}